import {isEmpty} from 'lodash-es';
import {useBootstrap, useRouter} from '@front/hooks';
import {fetch} from '@front/api/identification';

const {userProfile} = useBootstrap();

export function useGotoVerify(config = {}) {
    const {routerTo} = useRouter();
    const {verified, userProfile} = useBootstrap();

    async function onGotoVerify() {
        const records = await fetch({page: 0, size: 1});
        if (isEmpty(records.content)) {
            onFbViewContent();
            routerTo({name: 'menu.user.identification.new.step1'});
        } else {
            routerTo({name: 'menu.user.identification'});
        }
    }

    return {
        verified,
        onGotoVerify,
    };
}

function onFbViewContent() {
    window.fbq?.('track', 'ViewContent', {content_name: 'verification', contents: {userId: userProfile.value.accountId}});
}